// extracted by mini-css-extract-plugin
module.exports = {"timer":"Timer_timer__2Yc3E","message":"Timer_message__Wu-hI"};